import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DaterangepickerComponent } from './daterangepicker.component';
import { LocaleConfig, LOCALE_CONFIG } from './daterangepicker.config';
import { DaterangepickerDirective } from './daterangepicker.directive';
import { LocaleService } from './locale.service';

@NgModule({
    declarations: [DaterangepickerComponent, DaterangepickerDirective],
    exports: [DaterangepickerComponent, DaterangepickerDirective],
    imports: [CommonModule, FormsModule, ReactiveFormsModule],
    providers: []
})
export class NgxDaterangepickerMd {
	static forRoot(config: LocaleConfig = {}): ModuleWithProviders<NgxDaterangepickerMd> {
		return {
			ngModule: NgxDaterangepickerMd,
			providers: [
				{ provide: LOCALE_CONFIG, useValue: config },
				{ provide: LocaleService, useClass: LocaleService, deps: [LOCALE_CONFIG] }
			]
		};
	}
	constructor() {}
}
